import Marquee from "react-fast-marquee";

const ITEMS = [
    "Consulting WorX",
    "Websites",
    "Web Apps",
    "Custom CRM",
    "Free Discovery Calls",
    "1-on-1 AI Classes",
    "Workflow Automation",
];

export const Ribbon = () => (
    <div data-testid="manifesto-marquee" className="border-y border-ink/10 py-5 bg-paper overflow-hidden">
        <Marquee speed={30} gradient={false} pauseOnHover>
            {ITEMS.map((t) => (
                <span key={t} className="flex items-center">
                    <span className="font-display text-2xl md:text-3xl tracking-tight mx-8 text-ink">{t}</span>
                    <span className="text-worx text-xl font-display">✕</span>
                </span>
            ))}
        </Marquee>
    </div>
);
